module.exports = ".list-content {\n  display: block;\n  width: 100%;\n}\n.accordion i {\n  display: inline-block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/projects.component.less
// module id = ./src/app/projects/projects.component.less
// module chunks = main